'use client';

import React from 'react';
import type { AnalyticsConfig } from '../types';
import { useCosmicAnalytics } from './useCosmicAnalytics';

interface CosmicAnalyticsProviderProps {
  children: React.ReactNode;
  config?: AnalyticsConfig;
}

/**
 * Provider component for easy integration with Next.js layouts
 */
export function CosmicAnalyticsProvider({ 
  children, 
  config 
}: CosmicAnalyticsProviderProps) {
  // Read the environment variable here where Next.js can replace it
  const projectId = process.env.NEXT_PUBLIC_CLIENT_ID;
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  // Merge the projectId with the provided config
  const mergedConfig: AnalyticsConfig = {
    projectId,
    isDevelopment,
    ...config,
  };
  
  useCosmicAnalytics(mergedConfig);
  
  return <>{children}</>;
} 